// v2 rocks — a natural strewn scatter of small grey stones: an off-centre anchor
// stone, a flat slab fallen beside it and a loose ring of pebbles and shards
// thrown around them, so a tile reads as rocky ground litter. Each variant
// re-rolls the scatter deterministically. Ported 1:1 from age-of-mcp's
// v2/rocks.ts, using the library's shared `mineral` (h01, lerp, scree) helpers.
import * as THREE from "three";
import { defineModel, mineral, type Part } from "../../lib";

function rocksParts(v: number): Part[] {
  const seed = v * 13 + 7;
  const yaw = mineral.h01(seed, 0) * Math.PI * 2;
  const greys = ["#7c7f86", "#6e7178", "#888b91"] as const;
  const anchorR = mineral.lerp(0.18, 0.2, mineral.h01(seed, 1));
  const parts: Part[] = [
    // the anchor stone, set off-centre
    { geometry: new THREE.IcosahedronGeometry(anchorR, 0), color: greys[v % 3]!,
      position: [-0.1, anchorR * 0.62, 0.06],
      rotation: [mineral.h01(seed, 2) * 0.5, yaw, mineral.h01(seed, 3) * 0.4],
      scale: [1.15, 0.8, 1.0] },
    // a flat slab fallen against it
    { geometry: new THREE.BoxGeometry(0.24, 0.06, 0.17), color: greys[(v + 2) % 3]!,
      position: [0.12, 0.045, -0.12],
      rotation: [0.08, yaw + 0.9, -0.12] },
  ];
  // the loose ring of pebbles and shards around them
  parts.push(...mineral.scree(seed, 4 + (v % 2), [0.18, 0.34], [0.05, 0.1],
    greys));
  return parts;
}

export const rocksV2 = defineModel({
  id: "rocks-v2",
  batchId: "fable",
  name: "Rocks (v2)",
  tags: ["scenery","rocks","low-poly","age-of-mcp","fable"],
  summary: "Low-poly rocks.",
  description: "Ported from the age-of-mcp gallery, v2 style.",
  author: "age-of-mcp",
  footprint: 0.46,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => rocksParts(0) },
    { id: "variant-1", label: "Variant 2", parts: () => rocksParts(1) },
    { id: "variant-2", label: "Variant 3", parts: () => rocksParts(2) },
  ],
  animations: [],
});
